import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';

import { RegistrationStage } from '@ap/browser-authenticator';
import { ApContentService } from '@ap/content';
import { ApPersistenceService } from '@ap/persistence';

import { MijnTokensBrowserAnalyticsService } from '../analytics/analytics.service';
import { BrowserSessionName, BrowserSessionType } from '../mijn-tokens-browser.constants';
import { BrowserTokensSession } from '../mijn-tokens-browser.model';
import { MijnTokensBrowserNavigation } from '../mijn-tokens-browser.navigation';
import { MijnTokensBrowserService } from '../mijn-tokens-browser.service';

import content from './finished.wrapper.content.json';

/**
 * @module FinishedWrapperModule
 * @ngdoc component
 * @name FinishedWrapperComponent
 */
@Component({
    selector: 'tokens-browser-finished-wrapper',
    templateUrl: 'finished.wrapper.component.html',
    standalone: false
})
export class FinishedWrapperComponent implements OnInit {
    public constructor(
        private readonly activatedRoute: ActivatedRoute,
        private readonly analyticsService: MijnTokensBrowserAnalyticsService,
        private readonly contentService: ApContentService,
        private readonly navigation: MijnTokensBrowserNavigation,
        private readonly mijnTokensBrowserService: MijnTokensBrowserService,
        private readonly persistenceService: ApPersistenceService
    ) {}

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.navigation.init(this.activatedRoute.parent);
        this.setBrowserTokenVerified().subscribe(() => {
            this.persistenceService.clearSession(BrowserSessionName);
        });
        this.sendFormStepAnalytics();
    }

    public onLogin(): void {
        this.navigation.external(this.contentService.get('mijn.tokens.browser.finished.login.url'));
    }

    private sendFormStepAnalytics(): void {
        this.analyticsService.pushFormStepAnalytics(MijnTokensBrowserNavigation.FINISHED, 7, 'end');
    }

    private setBrowserTokenVerified(): Observable<void> {
        const storage: BrowserTokensSession = this.persistenceService.getSession(BrowserSessionName, BrowserSessionType);
        if (storage && storage.keychainId) {
            return this.mijnTokensBrowserService.setBrowserTokenStage(storage.keychainId, RegistrationStage.VERIFIED);
        }
        return of(null);
    }
}
